import React, {useEffect, useState} from "react";
import classes from "../Homepage/Homepage.module.css";
import {MDBAlert, MDBBadge, MDBBtn, MDBCol, MDBCollapse, MDBDropdownItem, MDBRow} from "mdbreact";
import CategoryCard from './CategoryCard/CategoryCard'
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {
    getAllCategories,
    getSubCategories,
    returnCategoryImage
} from "../../Utils/category";
import {Link} from "react-router-dom";
import ProgImg from "react-prog-img";
import {Trans} from "react-i18next";
import {SUPPORTED_FUNCTIONS} from "../../Utils/FunctionList";
import {Helmet} from "react-helmet";
import {returnTran} from "../../Utils/Trans";
import firebase from "../../Config/firebase";
import {timeAgo} from "../../Utils/converter";

const db = firebase.firestore()

const ListCategory = (props) => {
    const [lastUpdateDate, setLastUpdateDate] = useState('')
    useEffect(() => {
        firebase.analytics().logEvent('list_category_page', {});
        getLastUpdate()
    },[])

    const getLastUpdate = () => {
        db.collection('Data')
            .limit(1)
            .orderBy("createDate", "desc")
            .get()
            .then(docs => {
                if(!docs.empty){
                    setLastUpdateDate(docs.docs[0].data().createDate)
                }
            })

    }


    return (
        <>
            <Helmet>
                <title> { returnTran("LeftNavBar", "list-category")  + ' | MeWeSearcher | '+ returnTran("LeftNavBar", "description")}</title>
                {/*<meta property="fb:app_id" content="1293953327456577" />*/}
                <meta property="og:type" content="website" />
                <meta property="site_name" content="MeWeSearcher" />
                <meta property="title" content={ returnTran("LeftNavBar", "list-category")  + ' | MeWeSearcher | '+ returnTran("LeftNavBar", "description")}/>
                <meta name="description" content={ returnTran("LeftNavBar", "description")}/>
                <meta name="keywords" content={"mewe, search mewe, 找尋mewe群組, 香港mewe"}/>
                <meta property="og:title"
                      content={ returnTran("LeftNavBar", "list-category")  + ' | MeWeSearcher | '+ returnTran("LeftNavBar", "description")}/>
                <meta property="og:description" content={ returnTran("LeftNavBar", "description")}/>
                <meta property="og:url" content={"https://mewesearcher.com" + window.location.pathname}/>
                <meta property="og:site_name"
                      content={"MeWeSearcher | " + returnTran("LeftNavBar", "description")}/>
                {/*<meta property="og:updated_time"*/}
                {/*      content={new Date(this.state.article.lastModified.hasOwnProperty('seconds') ? this.state.article.lastModified.seconds * 1000 : this.state.article.lastModified._seconds * 1000 ).toISOString()}/>*/}
                <meta httpEquiv="content-language"
                      content={localStorage.getItem("i18n-lang") === "en" ? "en-us" : "zh-Hant"}/>
                <meta property="og:type" content="article"/>
                <meta property="og:image" content={"https://imgur.com/a/AMU0634"}/>
                <meta property="og:image:width" content="1280"/>
                <meta property="og:image:height" content="720"/>
                {/*<link rel="amphtml" href={"https://clipversity.com/amp/article/" + this.state.article.key}/>*/}
            </Helmet>
            <MDBRow>
                <MDBCol xl="12" lg="12" md="12" sm="12" xs="12">
                    <div className={classes.ListCategory}>
                        <MDBAlert color={'info'} className={classes.Alert}>
                            <Trans>ListCategory.cate-not-found</Trans>
                            <button className={classes.SuggestBtn}
                                    onClick={() => {
                                        props.setModalController({
                                            type: SUPPORTED_FUNCTIONS.REPORT_MODAL,
                                            typeOfModal: SUPPORTED_FUNCTIONS.REPORT_MODAL,
                                            isModalOpen: true,
                                            metadata: {itemID: "suggestion"}
                                        })
                                    }}
                            >
                                <Trans>ListCategory.suggest</Trans>
                            </button>
                        </MDBAlert>
                        <div className={classes.LastUpdate}>
                            <Trans>ListCategory.last-update</Trans>
                            {
                                lastUpdateDate !== '' ?
                                    timeAgo(lastUpdateDate.seconds)
                                    :
                                    ""
                            }
                        </div>
                        {
                            getAllCategories().map((c, index) => {
                                return (
                                    <div key={'category' + index} className={classes.CateItem}>
                                        <div className={classes.CateContainer}>
                                            <Link to={'/c/' + c.value}>
                                                <div className={classes.CateName}>
                                                    {c.label}
                                                </div>
                                            </Link>

                                            <div className={classes.CategoryAllContainer}>
                                                <Link to={'/c/' + c.value}>
                                                    <ProgImg effect="blur"
                                                             bg={'#eee'}
                                                             src={returnCategoryImage(c.value)}
                                                             alt={c.value}
                                                             conf={{isLazy: false}}
                                                             className={["darkmode-ignore", classes.CategoryImg].join(" ")}
                                                    />

                                                </Link>
                                            </div>
                                            <div className={classes.SubCateContainer}>
                                                {
                                                    getSubCategories(c.value).map((subC, cIndex) => {
                                                        return (
                                                            <Link to={{
                                                                pathname: '/c/' + c.value,
                                                                search: "?subCID=" + subC.value
                                                            }}
                                                                  key={'bad' + subC.value}>
                                                                <MDBBadge color={'light'} key={subC.value}
                                                                          className={classes.SubCateBadge}>
                                                                    {subC.label}
                                                                </MDBBadge>
                                                            </Link>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>

                                )
                            })
                        }

                    </div>
                </MDBCol>
            </MDBRow>
        </>
    )
}

const mapDispatchToProps = dispatch => {
    return {
        setModalController: (state) => dispatch({
            type: state.type,
            typeOfModal: state.typeOfModal,
            isModalOpen: state.isModalOpen,
            metadata: state.metadata
        })
    }
}
const mapStateToProps = state => {
    return {
        auth: state.firebase.auth
    }

}

const enhance = connect(
    mapStateToProps,
    mapDispatchToProps
)

export default enhance(withRouter(ListCategory))